import { i18n } from '../../../../common/services/globalize';

export const initiateVoucherPayment = (paymentMethod) => (dispatch, getState) => {
	const { voucherDataSubmitHandle } = getState().paymentProcessors[paymentMethod.name];
	const { voucherSchemeName, voucherSchemeReference } = voucherDataSubmitHandle();
	return new Promise((resolve, reject) => {
		if (!voucherSchemeName) {
			reject(i18n.t('FO_PaymentMethod_Voucher_SchemeNameRequired'));
		} else if (!voucherSchemeReference) {
			reject(i18n.t('FO_PaymentMethod_Voucher_SchemeReferenceRequired'));
		} else {
			resolve({ voucherSchemeName, voucherSchemeReference });
		}
	});
};